/**
 * @file Alert component (for all kinds of messages).
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Alert extends Component {
  static propTypes = {
    type: PropTypes.oneOf([
      'primary',
      'secondary',
      'success',
      'success-vibrant',
      'info',
      'note',
      'warning',
      'danger',
      'gray',
      'gray-light',
      'blue-pale',
      'blue-light',
      'blue-mid-light',
    ]),
    className: PropTypes.string,
    heading: PropTypes.string,
    global: PropTypes.bool,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
      PropTypes.string,
    ]).isRequired,
    onDismiss: PropTypes.func,
    dismissible: PropTypes.bool,
    defaultVisible: PropTypes.bool,
    visible: PropTypes.bool,
    borderless: PropTypes.bool,
  };

  static defaultProps = {
    defaultVisible: true,
  };

  state = {
    visible: this.props.defaultVisible,
  };

  onDismissClick = () => {
    const { onDismiss } = this.props;

    this.setState(
      () => ({
        visible: false,
      }),
      () => {
        if (onDismiss) {
          onDismiss();
        }
      },
    );
  };

  render() {
    const {
      type = 'primary',
      className,
      children,
      heading,
      global,
      dismissible,
      onDismiss,
      visible = this.state.visible,
      // Ignore props
      defaultVisible,
      borderless,
      ...props
    } = this.props;

    if (!visible) {
      return null;
    }

    const classes = classNames({
      alert: true,
      [`alert-${type}`]: true,
      'alert-global': global,
      'alert-dismissible': onDismiss || dismissible,
      'alert-borderless': borderless,
      [className]: className,
    });

    return (
      <div className={classes} {...props}>
        {heading && <h3 className="alert-heading">{heading}</h3>}
        {children}

        {(onDismiss || dismissible) && (
          <button
            className="btn-reset alert-dismiss"
            onClick={this.onDismissClick}
          >
            &times;
          </button>
        )}
      </div>
    );
  }
}

export default Alert;
